import styled from "styled-components";
import { Menu, Button, Row, Col } from "antd";
import { Body } from "sunday-component";
import { color } from "src/styles/globals";

export const MenuSubMenu = styled(Menu.SubMenu)`
  font-weight: bold;
  color: #2a2c2e !important;
  label {
    position: absolute;
    left: 0px;
  }
  ul > li {
    border-right: none !important;
    font-size: 21px;
    font-weight: normal;
  }
  .ant-menu-submenu-title {
    padding-left: 0px !important;
    padding-right: 0px !important;

    :hover {
      color: #fa4616;
    }
  }
`;

export const MobileMenu = styled.div``;

export const MenuButton = styled(Button)`
  width: 24px;
  height: 24px;
  padding: 0;
  color: #2b2b2b;

  span {
    font-size: 24px !important;
  }

  * {
    color: #2b2b2b;
  }
`;

export const DrawerContainer = styled.div`
  padding: 16px;
`;

export const MobileMenuContainer = styled(Menu)`
  border-right: none !important;
  font-size: 21px;
  a {
    color: #2a2c2e;
    white-space: normal;
    :hover {
      color: #fa4616;
    }
  }
  i {
    width: 26px;
  }
  i::after {
    background-color: #2a2c2e;
    width: 13px;
    height: 2.5px;
    left: 21px;
  }
  i::before {
    width: 13px;
    height: 2.5px;
    right: -12px;
    background-color: #2a2c2e;
  }
  .ant-menu-item:active,
  .ant-menu-submenu-title:active {
    background-color: #ffefe6;
  }

  .ant-menu-title-content {
    line-height: 22px;
  }
`;

export const MenuItem = styled(Menu.Item)`
  padding-left: 0px !important;
  padding-right: 0px !important;
`;

export const MobileMenuLinkBar = styled.div`
  margin-top: 16px;
`;

export const MobileMenuLinkIcon = styled.a`
  img {
    padding: 8px;
    margin-right: 1em;
  }
`;

export const ChangeLangItem = styled(Col)`
  align-self: center;
`;

export const ChangeLangContainer = styled(Row)`
  margin-bottom: 16px;
`;

export const ChangeLangText = styled(Body)`
  color: ${color.charcoal08};
`;

export const MenuText = styled.div`
  cursor: pointer;
  color: ${color.charcoal10};
  :hover {
    color: ${color.carrotOrange03};
  }
`;
